import { Form } from "react-bootstrap";
import AuditCard from "./AuditCard";
import SearchBlock from "./searchBlock";
import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import Api from "../../../api/Api";
import AuditBlockInterface from "./AuditBlockInterface";

const CurrentAuditsBlock = () => {
    const [loading, setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);
    const [dataFacility,setDataFacility]=useState(null);

    const getAudit = async() =>{
        try {
            const response=await Api({
                method:"get",
                url:"/audits/my_audits/current",
                headers:{}
            })
            return(response.data)
        } catch (error) {
            // throw "Ошибка при получении данных о текущих аудитах";
            throw `Ошибка при получении данных о текущих аудитах \n ${error}`;
        }
    }

    const getFacility = async() => {
        try {
            const response = await Api({
                method:"get",
                url:"/facilities/",
                headers:{}
            })
            return(response.data)
        }catch (error) {
            // throw "Ошибка при получении данных о заводах";
            throw `Ошибка при получении данных о заводах \n ${error}`;
        }
    }

    const getData = async() => {
        try {
            const FacilityData=await getFacility();
            setDataFacility(FacilityData);
            const AuditData= await getAudit();
            setData(AuditData);
            setBlock(true);
        } catch (error) {
            setErrorInfo(error);
            setError(true);
        }
    }

    useEffect(()=>{
        const setUp = async()=>{
            setLoading(true);
            await getData();
            setLoading(false);
        };
        setUp();
    },[])
    if (loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(
        <>
        <h5>Текущие</h5>
        <AuditBlockInterface facilityData={dataFacility} data={data}/>
        </>
        )
    }
}

export default CurrentAuditsBlock;